import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { ElementRef, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { ConfigService } from '../../services/config.service';
import { FaqService } from '../../services/faq.service';

/**
 * Component for displaying help FAQ.
 * A custom FAQ template can be loaded via a URL in the form of ~/../app/load/help/testfaq.html
 */
@Component({
	selector: 'faq',
	templateUrl: './faq.component.html',
	styleUrl: './faq.component.css'
})
export class FaqComponent implements OnInit {
	
	LOCALIZATION: any;
	Object = Object;

	templateContent: any;
	questions: { [key: string]: { [key: string]: { question: string; answer: string } } } = {};


	expandedKeys: string | null = null;

	constructor(
		private userService: UserService,
		private configService: ConfigService,
		private faqService: FaqService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadFaq();
	}
	
	loadFaq(): void {
		let groupName = this.userService.user?.group ?? undefined;

		this.faqService.getCustomFaq(groupName).then(
			(response: any) => {
				this.templateContent = response;
			},
			(err: any) => {
				this.loadDefaultFaq();
			}
		);
	}

	loadDefaultFaq(): void {
		this.faqService.getDefaultFaq().then(
			(response: any) => {
				this.questions = response;
			},
			(err: any) => {
				console.error("Failed to get FAQ", err);
			}
		);
	}

	toggleExpand(key: string): void {
		this.expandedKeys = this.expandedKeys === key ? null : key;
	}

	jumpToLocation(id: string): void {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			window.scrollBy(0, -60); // Adjust for offset
		}
	}
}
